import { cutToast } from 'utility/toast';
import { useMutation } from '@apollo/client';
import {
  DefaultButton,
  Modal,
  ProgressIndicator,
  RatingSize,
  Stack,
  TextField,
} from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import {
  RatingSupplierCreate,
  RatingSupplierCreateVariables,
} from 'settings/account/supplier/view/ReviewsRatings/__generated__/RatingSupplierCreate';
import { StarRatings } from '../../../../../../common/components/StarRatings';
import { ModalFooter } from './Footer';
import { ModalHeader } from './Header';
import { useStyles } from './index.styles';
import RATING_SUPPLIER_CREATE from '../../../../../../settings/account/supplier/view/ReviewsRatings/RatingSupplierCreate.graphql';
import SUPPLIER_DETAILS from '../../../SupplierDetails.graphql';
interface ReviewFormValues {
  ratingComment?: string | null;
  ratingValue: number;
}
interface ReviewFormProps {
  supplierId: string;
  refreshList: () => void;
}
export const ReviewForm: React.FC<ReviewFormProps> = ({
  supplierId,
  refreshList,
}) => {
  const styles = useStyles();

  const [reviewStarsRating, setReviewStarsRating] = useState<number>(1);
  const [reviewComment, setReviewComment] = useState<string>();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [addNewReview, { loading: loadingAddNewReview }] = useMutation<
    RatingSupplierCreate,
    RatingSupplierCreateVariables
  >(RATING_SUPPLIER_CREATE);
  const handleSubmitReview = async (values: ReviewFormValues) => {
    const { errors } = await addNewReview({
      variables: {
        input: {
          rating: {
            entityId: supplierId,
            ratingValue: values.ratingValue,
            ratingComment: values.ratingComment,
          },
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: SUPPLIER_DETAILS,
          variables: {
            id: supplierId,
          },
        },
      ],
    });
    setIsModalOpen(false);
    if (errors?.length) {
      cutToast.error(errors[0].message);
    } else {
      setReviewComment('');
      setReviewStarsRating(1);
      setIsSubmitDisabled(true);
      cutToast.success('Rating added successfully');
      refreshList();
    }
  };
  useEffect(() => {
    if (reviewComment) {
      setIsSubmitDisabled(false);
    } else setIsSubmitDisabled(true);
  }, [reviewComment]);

  return (
    <Stack className={styles.container}>
      <Stack horizontalAlign="end" className={styles.defaultButtonContainer}>
        <DefaultButton
          text="Add New Review"
          onClick={() => setIsModalOpen(true)}
        />
      </Stack>
      {
        <Modal isOpen={isModalOpen} isBlocking>
          <Stack className={styles.wrapper}>
            <ModalHeader onClose={() => setIsModalOpen(false)} />
            <Stack
              tokens={{ childrenGap: 10 }}
              className={styles.ratingsFormContainer}
            >
              <StarRatings
                min={1}
                max={5}
                size={RatingSize.Large}
                onChange={(e, rating) => {
                  if (rating) setReviewStarsRating(rating);
                }}
              />
              <TextField
                label="Write your review"
                multiline
                resizable={false}
                onChange={(_e, comment) => {
                  setReviewComment(comment);
                }}
              />
            </Stack>
            {loadingAddNewReview && <ProgressIndicator />}
            <ModalFooter
              disableSubmit={isSubmitDisabled}
              onCancelPress={() => setIsModalOpen(false)}
              onSubmitPress={() =>
                handleSubmitReview({
                  ratingComment: reviewComment,
                  ratingValue: reviewStarsRating,
                })
              }
            />
          </Stack>
        </Modal>
      }
    </Stack>
  );
};
